export const CONTACT_GROUP_PREVIEW_LIMIT = 3;

export function contactGroupPreview<T>(groups: readonly T[]): {
  visible: T[];
  remaining: number;
} {
  if (groups.length <= CONTACT_GROUP_PREVIEW_LIMIT) {
    return { visible: [...groups], remaining: 0 };
  }

  return {
    visible: groups.slice(0, CONTACT_GROUP_PREVIEW_LIMIT),
    remaining: groups.length - CONTACT_GROUP_PREVIEW_LIMIT,
  };
}
